module.exports = __webpack_public_path__ + "img/112.09fc9a8e.jpg";